import { createCrudEndpoints, createExportEndpoint } from '@/core/utils'
import { TMill, TMills } from '.'

export const serviceConfig = {
  model: 'mills',
  version: 'v1',
}

const moduleServiceHandlers = createCrudEndpoints<TMills, TMill>(
  serviceConfig.model,
  serviceConfig.version,
)
const moduleExportHandlers = createExportEndpoint(serviceConfig.model)

export { moduleServiceHandlers, moduleExportHandlers }
